import { Modal } from '@sonans/components'
import React, { useState } from 'react'
import InfoIcon from '@/assets/info.svg?react'

type Props = {
    title?: string | React.ReactNode
    content: string | React.ReactNode
}

export function Popup({ content, title }: Props) {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <>
            <Modal open={isOpen} onClose={() => setIsOpen(false)}>
                {title && (
                    <h3 className="text-base md:text-lg font-bold mb-4">{title}</h3>
                )}
                <div className="text-sm md:text-base">{content}</div>
            </Modal>
            <button onClick={() => setIsOpen(true)}>
                <InfoIcon className="w-5" />
            </button>
        </>
    )
}
